import { render } from "./CookieModalContent.vue?vue&type=template&id=d09e626e&scoped=true&ts=true"
import script from "./CookieModalContent.vue?vue&type=script&lang=ts"
export * from "./CookieModalContent.vue?vue&type=script&lang=ts"

import "./CookieModalContent.vue?vue&type=style&index=0&id=d09e626e&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d09e626e"]])

export default __exports__